import { Reveal } from "@/components/Reveal";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data";

export const Testimonials = () => {
  const loop = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-stone-50 py-20 sm:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 mb-12">
        <Reveal>
          <p className="overline text-kw-red mb-4">Client Reviews</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-kw-ink max-w-3xl leading-[1.02]">
            Denver buyers and sellers who got the result they wanted.
          </h2>
        </Reveal>
      </div>

      <div className="marquee-pause relative">
        <div className="flex w-max gap-6 animate-marquee px-5 sm:px-8">
          {loop.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="w-[330px] sm:w-[420px] shrink-0 bg-white border border-neutral-200 p-8"
            >
              <Quote className="text-kw-red mb-4" size={26} />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="fill-kw-red text-kw-red" />
                ))}
              </div>
              <p className="text-sm sm:text-base text-neutral-700 leading-relaxed">{t.text}</p>
              <p className="mt-5 font-serif text-xl text-kw-ink">{t.name}</p>
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-stone-50 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-stone-50 to-transparent" />
      </div>
    </section>
  );
};
